export default __webpack_public_path__ + "static/media/phone.e3da8bc9.svg";